<div class="m-story-comments">
  <!--<div *ngIf="showTitle" class="story-comments__title m-story-title text-gray-dark">Comments</div>-->
  <div *ngIf="isLoggedIn" class="story-comments__conts">
    <app-comments [isMasterAdmin]="false"  (noComents)="showComentTitle($event)" [inbound]="true" [resourceType]="resourceType" [resourceId]="storyDetail?.id"></app-comments>
  </div>
</div>